import Chip from '@/components/atoms/chip';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms/Tooltip';
import { useStore } from '@/store';
import { Chunk } from '@/types';

const DocumentChunk = ({ chunk }: { chunk: Chunk }) => {
  const { openReferenceDrawer } = useStore();

  return (
    <div className="w-full rounded-lg border p-4 py-2.5 pb-4" key={chunk.id}>
      <div className="mb-1 flex justify-between">
        <div className="mt-1 mb-1 font-semibold">Source Text:</div>

        <div className="flex items-center gap-2">
          <span
            className="cursor-pointer text-blue-600"
            onClick={() => {
              openReferenceDrawer({ chunkId: chunk.id, caseId: chunk.caseId });
            }}
          >
            <TooltipProvider>
              <Tooltip delayDuration={0}>
                <TooltipTrigger asChild>
                  <p className="line-clamp-1 max-w-28 break-all text-ellipsis">{chunk.doc.file.name}</p>
                </TooltipTrigger>

                <TooltipContent className="max-w-56 bg-gray-50">
                  <p className="text-xs text-gray-800">{chunk.doc.file.name}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </span>

          <Chip className="bg-brandTertiary/10 text-brandTertiary">{chunk.doc.type}</Chip>
        </div>
      </div>

      <p>{chunk.content}</p>
    </div>
  );
};

export default DocumentChunk;
